// ─────────────────────────────────────────────────────────────────────────
//  ClickViewer · web · 가짜 응답 (VITE_MOCK=1 일 때만)
//
//  ★ **기본으로 켜지 않는다.** `config.ts` 의 USE_MOCK 이 false 면 이 파일의 코드는
//    번들에서 통째로 빠진다(vite 가 import.meta.env.VITE_MOCK 을 빌드 때 상수로 바꾼다).
//  ★ 이게 있는 이유는 딱 하나 — API 가 안 떠 있을 때 **화면 배치를 만지기 위해서**다.
//    "API 가 없으니 가짜로 때우자" 가 아니다. 연결 실패 화면은 mock 없이 봐야 한다.
//  ⚠️ 여기서 잘 도는 것은 **아무것도 증명하지 않는다.** 쿠키도 RLS 도 속도 제한도 없다.
// ─────────────────────────────────────────────────────────────────────────

import { LOGIN_CODE_DIGITS } from '../config';

/** mock 에서 통과하는 코드. 자릿수는 진짜와 맞춘다(안 맞으면 PinInput 이 안 채워진다). */
export const MOCK_CODE = '1'.repeat(LOGIN_CODE_DIGITS);

/** 진짜 세션 대신 쓰는 변수. 새로고침하면 사라진다 — 쿠키가 아니니 당연하다. */
let signedIn = false;

/** 사람이 로딩 상태를 실제로 볼 수 있을 만큼만 느리게. */
const DELAY_MS = 350;

function reply(status: number, body: unknown): Response {
  return new Response(body === undefined ? null : JSON.stringify(body), {
    status,
    headers: { 'content-type': 'application/json; charset=utf-8' },
  });
}

const MOCK_ME = {
  user: {
    id: '00000000-0000-0000-0000-000000000001',
    email: 'mock@example.com',
    name: '가짜 사용자',
    is_superadmin: false,
  },
  projects: [
    { id: '11111111-1111-1111-1111-111111111111', slug: 'dangjin', name: '당진 고속도로', belt: 'EPSG:5186' },
    { id: '22222222-2222-2222-2222-222222222222', slug: 'seosan', name: '서산 우회도로', belt: 'EPSG:5186' },
  ],
};

export const mockFetch: typeof fetch = async (input, init) => {
  const path = typeof input === 'string' ? input : input instanceof URL ? input.pathname : input.url;
  await new Promise((r) => setTimeout(r, DELAY_MS));

  let body: Record<string, unknown> = {};
  if (typeof init?.body === 'string') {
    try {
      body = JSON.parse(init.body) as Record<string, unknown>;
    } catch {
      /* 무시 */
    }
  }

  if (path === '/api/auth/code') {
    // 진짜와 같이 **무조건 204**. 코드가 어디로 갔는지는 콘솔로만 알 수 있다 —
    // 진짜 API 도 dev 에서는 wrangler 콘솔에만 찍는다(CV_MAIL_PROVIDER=console).
    console.info(`[mock] 로그인 코드: ${MOCK_CODE}`);
    return reply(204, undefined);
  }

  if (path === '/api/auth/verify') {
    if (body['code'] === MOCK_CODE) {
      signedIn = true;
      return reply(200, { ok: true });
    }
    return reply(401, { e: 'unauthorized' });
  }

  if (path === '/api/auth/logout') {
    signedIn = false;
    return reply(204, undefined);
  }

  if (path === '/api/me') {
    return signedIn ? reply(200, MOCK_ME) : reply(401, { e: 'unauthorized' });
  }

  // 모르는 경로는 진짜와 같이 404 상수 하나.
  return reply(404, { e: 'not_found' });
};
